import { Component, Input, OnInit } from '@angular/core';
import { WidgetsEntity } from "../../models/widget-entity.model";

@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  @Input() widgets?: (WidgetsEntity | null)[] | null;

  ngOnInit(): void {
    console.log(this.widgets);
  }

}
